define(['jquery'], function($) {

    function LanguageHint() {}

    LanguageHint.prototype.init = function() {
        const _this = this;


        const availableLanguages = ['de', 'en', 'fr', 'it'];
        const availableCountriesByLanguage = {
            'de': ['ch', 'at', 'de'],
            'en': ['int'],
            'fr': ['ch'],
            'it': ['ch']
        };
        let hintLanguage = 'en',
            recommendedLanguage = 'en',
            recommendedCountry = 'int';

        // fetch country & language from URL
        const dimensionSegment = window.location.pathname.split('/')[1];

        const locale = dimensionSegment ? dimensionSegment : 'ch-de';
        const hb180BauwerkLanguageChosen = localStorage.getItem('hb180-bauwerk-language-choosen')

        if (hb180BauwerkLanguageChosen !== locale) {
            const redirectUrl = $('#languageHint li[data-locale=' + hb180BauwerkLanguageChosen + '] a').attr('href')
            if (redirectUrl !== undefined && ($('body:not(.neos-backend)').length > 0)) {
                location.href = redirectUrl
            }
        }

        // check if hint has been closed in the past
        if (_this.isStorageAvailable() && localStorage.getItem('hb180-bauwerk-language-hint-dismissed')) {
            console.log('dismissed earlier, hint skipped');
            return;
        }
        // fetch desired language(s) from browser
        const requestedLocales = navigator.languages || [navigator.language];
        let requestedLanguage = requestedLocales[0].split('-')[0];
        let requestedCountry = requestedLocales[0].split('-')[1] ? requestedLocales[0].split('-')[1].toLowerCase() : '';

        // does the first desired language match the current? return!
        if (typeof language !== 'undefined') {
            if (language === requestedLanguage && (country === '' || country === requestedCountry)) {
                return;
            }
        }

        // loop over desired languages and check for match
        requestedLocales.every(function(requestedLocale) {
            requestedLanguage = requestedLocale.split('-')[0];
            requestedCountry = requestedLocale.split('-')[1] ? requestedLocale.split('-')[1].toLowerCase() : '';
            if (availableLanguages.indexOf(requestedLanguage) !== -1) {
                hintLanguage = requestedLanguage;
                recommendedLanguage = requestedLanguage;
                if (requestedCountry !== '' && availableCountriesByLanguage[requestedLanguage].indexOf(requestedCountry) !== -1) {
                    recommendedCountry = requestedCountry;
                } else {
                    recommendedCountry = availableCountriesByLanguage[requestedLanguage][0];
                }
                return false;
            }
            return true;
        });

        console.log('hinting at ' + recommendedCountry + '-' + recommendedLanguage + ' using ' + hintLanguage)

        // handle open/close selector & item selected
        $('#languageHint .language__selector a').on('click', function(e) {
            e.stopPropagation();
            e.preventDefault();
            const $link = $(e.target);
            const $selector = $(e.target).closest('.language__selector');
            if ($selector.hasClass('language__selector__active') === false) {
                // not using jQuery here to avoid magic blocking event propagation
                document.getElementsByTagName('body')[0].onclick = function() {
                    $('.language__selector__active').removeClass('language__selector__active');
                }
                $selector.addClass('language__selector__active');
            } else {
                $selector.find('li.current').removeClass('current').addClass('normal');
                $link.closest('li').removeClass('normal').addClass('current');
                $selector.removeClass('language__selector__active');
            }
        });
        // handle submit choice
        $('#languageHint .language__hint__submit').on('click', function() {
            if (_this.isStorageAvailable()) {
                localStorage.setItem('hb180-bauwerk-language-hint-dismissed', true);
                localStorage.setItem('hb180-bauwerk-language-choosen', $('#languageHint li.current').data('locale'));
            }
            location.href = $('#languageHint li.current a').attr('href');
        });

        // handle dismiss hint
        $('#languageHint .language__hint__close').on('click', function() {
            $('#languageHint').hide();
            $('.mm-page').css('top', '0');
            $('.p__header').css('top', '0');
            if (_this.isStorageAvailable()) {
                localStorage.setItem('hb180-bauwerk-language-hint-dismissed', true);
            }
        });

        // show hint
        $('#languageHint li').removeClass('current').addClass('normal')
        $('#languageHint li[data-locale=' + recommendedCountry + '-' + recommendedLanguage + ']').removeClass('normal').addClass('current')
        $('#languageHint .language__hint__content--' + hintLanguage).css('display', 'inline-block');
        $('.mm-page').css('top', '80px');
        $('.p__header').css('top', '70px');
        $('#languageHint').css('display', 'flex');
    };

    LanguageHint.prototype.isStorageAvailable = function() {
        let storage;
        try {
            storage = window.localStorage;
            const x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && (
                    // everything except Firefox
                    e.code === 22 ||
                    // Firefox
                    e.code === 1014 ||
                    // test name field too, because code might not be present
                    // everything except Firefox
                    e.name === 'QuotaExceededError' ||
                    // Firefox
                    e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
                // acknowledge QuotaExceededError only if there's something already stored
                (storage && storage.length !== 0);
        }
    };

    return LanguageHint;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/languageHint.js